import * as React from "react";
import { useMemo } from "react";
import { useTranslations } from "../../i18n/useTranslations";
import { SearchList } from "../SearchList";

type Props = {
  suggestions: string[];
  searchText: string;
};

export const SearchSuggestions = ({ suggestions, searchText }: Props) => {
  const { t } = useTranslations();
  const showSuggestions = useMemo(() => suggestions.length > 0, [suggestions]);

  const props = {
    searchItems: suggestions,
    listType: "suggestions",
    searchText
  };

  return (
    showSuggestions && (
      <div className="elm-py-5 md:elm-p-5 md:elm-pt-0">
        <div
          role="heading"
          className="elm-text-dd-gray-900 elm-font-sans elm-text-sm elm-font-normal elm-uppercase elm-mt-2 elm-mb-1 md:elm-mt-0  md:elm-border-0 md:elm-border-t md:elm-border-solid elm-border-dd-gray-300 md:elm-pt-6"
        >
          {t("Suggestions")}
        </div>
        <SearchList {...props} />
      </div>
    )
  );
};
